import React, {FC} from 'react';
import styled from "../../theme";

const Copyright:FC = () => {
    return (
        <CopyrightStyled>Разработчик
            <LinkStyled href="https://pahomov.pro" target="_blank" rel="noreferrer">pahomov.pro</LinkStyled>
        </CopyrightStyled>
    )
}

const CopyrightStyled = styled.div`
  font-size: 12px;
  color: black;
  font-weight: 600;
  position: absolute;
  bottom: -90px;
  right: 32px;
  padding: 20px 0;
`;

const LinkStyled = styled.a`
  font-size: 12px;
  color: black;
  font-weight: 600;
  margin-left: 5px;
  text-decoration: underline;
`;

export default Copyright;
